import { ReactElement } from 'react';

import { LabelDescriptionItem } from '$components/label-description-item/label-description-item';

type UserListItemProps = {
  name: string;
  userRole?: string;
};

export function UserListItem({ name, userRole }: UserListItemProps): ReactElement {
  return <LabelDescriptionItem label={name} description={userRole} />;
}
